module.exports = __webpack_public_path__ + "assets/img/app-7.7e42d6a5.png";